'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAll = exports.fetchConfigFor = undefined;

var _http = require('./util/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function baseUrl(stackName) {
  return '/api/configuration/' + stackName;
}

function fetchConfigFor() {
  var $args = arguments;
  return new Promise(function ($return, $error) {
    var stackName;
    stackName = $args.length > 0 && $args[0] !== undefined ? $args[0] : 'all';

    var $Try_1_Post = function $Try_1_Post() {
      try {
        return $return();
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };

    var $Try_1_Catch = function $Try_1_Catch(error) {
      try {
        throw error;
      } catch ($boundEx) {
        return $error($boundEx);
      }
    };

    try {
      return Promise.resolve(_http2.default.get('' + baseUrl(stackName))).then($return, $Try_1_Catch);
    } catch (error) {
      $Try_1_Catch(error);
    }
  });
}

function loadAll() {
  return new Promise(function ($return, $error) {
    return Promise.resolve(fetchConfigFor()).then($return, $error);
  });
}

exports.fetchConfigFor = fetchConfigFor;
exports.loadAll = loadAll;